import React from "react";
import Container from 'react-bootstrap/Container';
import { Outlet } from 'react-router-dom';
import LeftNav from "../layout/LeftNav";
import TopNav from "../layout/TopNav";



function AdminLayout() {
    return (
        <Container className="dashboard-container px-0" fluid>
              <LeftNav></LeftNav>
              <main className="main-content">
                <TopNav></TopNav>
                <Outlet />
              </main>  
        </Container>                    
    );
}

export default AdminLayout;